import { useEffect, useState } from 'react';
import { AppState } from 'react-native';
import { useAuthStore } from '@/store';
import { checkWorkRecommendationAccess } from '@/lib/workRecommendationAccess';
import { getWorkAccessRequirement, getWorkAccessStatus } from '@/constants/utils/chat_work_access';

export default function useWorkRecommendationAccess(prompt, collectionId) {
  const userId = useAuthStore(state => state.user?.id);
  const [result, setResult] = useState(null);
  const requirement = getWorkAccessRequirement(prompt);
  const needsCheck = ['local-files', 'local-browser'].includes(requirement);
  const key = `${userId}:${collectionId || ''}:${requirement}`;
  useEffect(() => {
    if (!needsCheck) return undefined;
    let active = true;
    let revision = 0;
    const check = async () => {
      const thisRevision = ++revision;
      const access = await checkWorkRecommendationAccess(prompt, collectionId);
      if (active && revision === thisRevision) setResult({ key, access });
    };
    void check();
    const subscription = AppState.addEventListener('change', state => { if (state === 'active') void check(); });
    return () => { active = false; subscription.remove(); };
  }, [needsCheck, key, prompt, collectionId]);
  return needsCheck ? (result?.key === key ? result.access : { canLaunch: false, notice: 'checkingAccess' })
    : getWorkAccessStatus(requirement);
}
